import React, { useState, useEffect } from "react";
import { postData } from "../../../../../ApiServices/ApiService";
import { ORG_INVOICE } from "../../../../../ApiServices/BaseURL";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../../Utils/Exception";

const InvoiceReceiptNotesController = (narrationText, notesText, errorSettings, onRefresh) => {
    const [narration, setNarration] = useState("");
    const [notes, setNotes] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [narrationError, setNarrationError] = useState("");
    const [notesError, setNotesError] = useState("");
    const { setIsLoginPopup } = useTheme();

    const pageName ="InvoiceReceiptNotesController"
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    useEffect(() => {
        setNarration(narrationText || "");
        setNotes(notesText || "");
        setError(errorSettings);
    }, [narrationText, notesText, errorSettings]);

    const handleUpdateReceiptNarration = async () => {

        try {
            setError('');
            setSuccess('');
            setNarrationError("");
            setNotesError("");

            if (!narration) {
                setNarrationError("Please enter the narration");
                return;
            }

            if (!notes) {
                setNotesError("Please enter the notes");
                return;
            }

            setLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "action": "NARRATION_NOTES_UPDATE",
                "acc_narration": narration,
                "acc_notes": notes,
            }

            //console.log('handleUpdateTaskType Data', payLoad);
            // Make the API call
            const response = await postData(ORG_INVOICE, payLoad);
            const responseData = await response.json();
            //console.log('handleUpdateTaskType response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setSuccess(responseData?.info);
                        setTimeout(() => {
                            setSuccess('');
                            setIsEditing(false);
                            onRefresh();
                        }, 3000);
                    } else {
                        setError(responseData?.info || 'Failed to Update Task Type data. Please try again.');
                        logFrontendException(storedUserId, pageName, "handleUpdateReceiptNarration", responseData?.info || '');
                    }
                } else {
                    setError(responseData?.info || 'Failed to Update Task Type data.');
                    logFrontendException(storedUserId, pageName, "handleUpdateReceiptNarration", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "handleUpdateReceiptNarration", response || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "handleUpdateReceiptNarration", response || '');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            
            // Unexpected or network-related errors
            else {
                setError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "handleUpdateReceiptNarration", response || '');
            }
        } catch (error) {
           
                setError(`Something went wrong while processing your request. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "handleUpdateReceiptNarration-catch", error || '');
            
        } finally {
            setLoading(false);
        }


        // onValueChange(clientData); // Send data to Dashboard
        // onClose(); // Close modal
    };

    return {
        narration,
        setNarration,
        notes,
        setNotes,
        handleUpdateReceiptNarration,
        loading,
        error,
        success,
        isEditing,
        setIsEditing,
        narrationError,
        notesError,
    };
}

export default InvoiceReceiptNotesController;
